<template>
  <v-container>
    <v-layout align-center justify-center>
      <v-dialog
        v-model="cardsDisabled"
        width="300"
        persistent
      >
        <v-card>
          <v-card-text>
            Processando...
            <v-progress-linear indeterminate/>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
    <card-carregando
      v-if="loading"
    />
    <v-card v-else>
      <v-toolbar
        dark
        color="primary"
      >
        <v-toolbar-title>Recurso da Indicação</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-form
          ref="form_recurso_indicacao"
          v-model="valid"
          lazy-validation
        >
          <v-tabs
            v-model="tabs"
            centered
            icons-and-text
            show-arrows
          >
            <v-tab
              v-for="(indicado, index) in indicadosConselho"
              :key="indicado.co_indicado_conselho"
              :href="`#tab-${index+1}`"
              @click="setIndicado(indicado)"
            >
              {{ index+1 }}º Representante
              <v-icon
                center
                class="text--lighten-2"
              >
                people
              </v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items
            v-model="tabs"
          >
            <v-tab-item
              v-for="(indicado, index) in indicadosConselho"
              :key="indicado.co_indicado_conselho"
              :value="`tab-${index+1}`"
            >
            <v-card>
              <v-card-text>
                    <v-layout justify-space-between wrap>
                                <v-flex sm3>
                                    <v-text-field :value="indicado.nu_cpf" label="CPF do indicado"
                                        append-icon="people_outline" disabled />
                                </v-flex>
                                <v-flex sm8>
                                    <v-text-field :value="indicado.no_nome" label="Nome do indicado"
                                        append-icon="people_outline" disabled />
                                </v-flex>
                      </v-layout>
                      <v-layout class="mt-3" wrap align-center>
                        <v-flex xs12 sm12 lg12>
                            <v-card>
                                <v-card-title color="white darken-3">
                                    <h3><b>Avaliação</b></h3>
                                </v-card-title>
                                <v-layout>
                                    <v-flex class="pa-3">
                                        <v-radio-group column v-model="indicado.st_habilitacao"
                                        disabled>
                                            <v-radio value="1" color="success">
                                                <template v-slot:label>
                                                    <div><strong class="success--text">Habilitado</strong></div>
                                                </template>
                                            </v-radio>
                                            <v-radio value="0" color="error">
                                                <template v-slot:label>
                                                    <div><strong class="error--text">Inabilitado</strong></div>
                                                </template>
                                            </v-radio>
                                        </v-radio-group>
                                    </v-flex>
                                </v-layout>
                                <v-layout>
                                    <v-flex class="pa-3">
                                        <v-textarea v-model="indicado.ds_parecer" box label="* Parecer"
                                            name="input-7-4" rows="13" row-height="28" :counter="3000"
                                            disabled />
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-flex>
                    </v-layout>
                  </v-card-text>
              </v-card>
              <v-card
                v-if="indicado.st_habilitacao == 0"
                class="pt-2"
              >
                <v-flex
                  title
                  ma-3
                >
                  Dados do Recurso
                </v-flex>
                <v-card
                  class="ma-4"
                  wrap
                  align-center
                >
                  <v-card-text>
                    <v-layout
                      v-if="indicado.st_habilitacao == 0"
                    >
                      <v-flex
                        sm12
                      >
                        <v-flex
                          title
                          my-3
                        >
                          Descrição
                        </v-flex>
                        <v-textarea
                          v-model="recurso_indicacao_conselho.ds_recurso"
                          box
                          label="* Descrição do Recurso"
                          name="input-7-4"
                          rows="13"
                          row-height="28"
                          no-resize
                          :rules="[rules.required, rules.tamanhoMaximoCaracteres]"
                          :disabled="recursoSolicitado()"
                        />
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
                <v-layout
                  v-if="indicado.st_habilitacao == 0 && !recursoSolicitado() && ativarRecursoIndicacaoConselho"
                >
                  <v-flex offset-xs5>
                    <v-btn to="/">
                      Cancelar
                    </v-btn>
                    <v-btn
                      :readonly="!recurso_indicacao_conselho.ds_recurso"
                      :disabled="!valid"
                      color="primary"
                      @click="abrirDialogo"
                    >
                      Enviar
                    </v-btn>
                  </v-flex>
                </v-layout>
                <v-card
                  v-else-if="recursoSolicitado()"
                >
                        <v-flex
                          headline
                          text-xs-center
                          success
                          white--text
                          font-weight-medium 
                          
                        >
                          Recurso solicitado!<br/> Você pode continuar a editar os arquivos durante o perído de Recurso da Indicação 
                        </v-flex>
                </v-card>
                <v-card
                  class="ma-4"
                  wrap
                  align-center
                >
                  <v-card-text>
                    <v-flex
                      title
                      my-3
                    >
                      Documentos
                    </v-flex>
                    <v-flex
                      sm12
                      mx-3
                    >
                      A documentação deve estar legível, ser digitalizada e anexada em formato PDF (preferencialmente) ou JPEG, cujo tamanho não exceda 100 MB.
                    </v-flex>
                    <v-flex
                      sm12
                      mx-3
                    >
                      <a
                        target="_blank"
                        href="http://cnpc.cultura.gov.br/wp-content/uploads/sites/3/2022/08/ANEXOS-INDICA%C3%87%C3%83O-CONSELHO-1.pdf"
                      >Modelo de declaração de autorização de uso de imagem <v-icon
                        color="primary"
                        small
                      >open_in_new</v-icon></a>
                    </v-flex>
                    <v-flex
                      sm12
                      mt-1
                      mx-3
                    >
                      <a
                        target="_blank"
                        href="http://cnpc.cultura.gov.br/wp-content/uploads/sites/3/2022/08/ANEXOS-INDICA%C3%87%C3%83O-CONSELHO-1.pdf#page=3"
                      >Modelo de declaração de residência<v-icon
                        color="primary"
                        small
                      >open_in_new</v-icon></a>
                    </v-flex>
                    <v-layout
                      row
                      wrap
                      justify-center
                    >
                      <v-flex
                        v-for="arquivo in arquivos"
                        :key="arquivo.tp_arquivo"
                        sm4
                        pa-3
                        style="max-width: 300px;"
                        text-xs-center
                      >
                        <v-card>
                          <v-card-title style="height: 200px;">
                            <v-flex>{{ arquivo.title }}</v-flex>
                          </v-card-title>
                          <v-card v-if="indicado.arquivos.find(a => a.tp_arquivo == arquivo.tp_arquivo) && ativarRecursoIndicacaoConselho">
              <v-card-title>
              <v-flex v-if="indicado.arquivos.find(a => a.tp_arquivo == arquivo.tp_arquivo).arquivo.situacaoArquivo.st_situacao == 'PENDENTE_AVALIACAO'" mt-1 class="white--text" font-weight-medium secondary>
                Pendente Avaliação
              </v-flex>
            <v-flex v-else-if="indicado.arquivos.find(a => a.tp_arquivo == arquivo.tp_arquivo).arquivo.situacaoArquivo.st_situacao == 'REGULAR'" mt-1 class="white--text" font-weight-medium success>
               Regular
            </v-flex>
              <v-flex v-else
                mt-1
               class="white--text">
                <v-flex  error>
                  Irregular
                </v-flex>
                <v-btn 
                  block
                  small
                  style="height:16px"
                  mt-1 
                  color="grey"
                  font-weight-medium 
                  @click="abrirDialogoSituacaoArquivo(indicado.arquivos.find(a => a.tp_arquivo == arquivo.tp_arquivo))">
                      Detalhes
                </v-btn>
              </v-flex>
            </v-card-title>
            </v-card>
                          <v-card>
                            <v-card-text v-if="(!indicado.arquivos.find(a => a.tp_arquivo == arquivo.tp_arquivo)) && ativarRecursoIndicacaoConselho">
                              <SingleFileUpload
                                :co-objeto="indicado.co_indicado_conselho"
                                :tp-arquivo="arquivo.tp_arquivo"
                                file-path="indicacao_conselho"
                                :accepted-file-types="acceptedFileTypes"
                                @upload="desabilitaCards"
                                @removerArquivo="removerArquivo"
                                @sucesso="obterIndicadosPorConselho(conselho.co_conselho)"
                              />
                            </v-card-text>
                            <v-card-text v-else-if="indicado.arquivos.find(a => a.tp_arquivo == arquivo.tp_arquivo)">
                              <v-flex max-width="50">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{on}">
                                    <v-btn
                                      color="blue-grey"
                                      outline
                                      @click="downloadArquivo(indicado.arquivos.find(a => a.tp_arquivo == arquivo.tp_arquivo).co_arquivo)"
                                      v-on="on"
                                    >
                                      <v-icon

                                        dark
                                      >
                                        cloud_download
                                      </v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Download</span>
                                </v-tooltip>
                                <v-tooltip
                                  v-if="ativarRecursoIndicacaoConselho"
                                  bottom
                                >
                                  <template v-slot:activator="{on}">
                                    <v-btn
                                      color="error"
                                      outline
                                      @click="removerArquivo(indicado.arquivos.find(a => a.tp_arquivo == arquivo.tp_arquivo).co_arquivo)"
                                      v-on="on"
                                    >
                                      <v-icon

                                        dark
                                      >
                                        delete
                                      </v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Excluir</span>
                                </v-tooltip>
                              </v-flex>
                            </v-card-text>
                            <v-card-text v-else>
                              <v-flex mt-1 class="white--text" font-weight-medium grey darken-1>
                                Arquivo não enviado
                              </v-flex>
                            </v-card-text>
                          </v-card>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-card>
              
            </v-tab-item>
          </v-tabs-items>
        </v-form>
      </v-card-text>
    </v-card>

    <v-layout justify-center>
      <dialog-confirmacao
        v-model="dialog"
        title="Deseja realmente enviar?"
        text="Os dados enviados não poderão ser alterados posteriormente."
        cancel-text="Não"
        confirm-text="Sim"
        :is-loading="loading"
        @dialog-response="respostaDialog"
      />
    </v-layout>

    <v-layout justify-center>
      <v-dialog
          v-model="modalSituacaoArquivo"
          max-width="800"
        >
      <v-card
        v-if="modalSituacaoArquivo"
                  min-height="55"
                  class="elevation-1"
                >
                <v-toolbar
          dark
          color="secondary"
        >

          <v-toolbar-title>
           Situação do Arquivo 
          </v-toolbar-title>
          <v-spacer />
          <v-btn
            icon
            dark
            @click="fecharDialogoSituacaoArquivo()"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
                  <v-layout>
                    <v-flex>
                      <v-flex title text--secondary mt-3 ml-4 >
                          {{ conselhoUtils.descricaoArquivosIndicacao[arquivoSelecionado.tp_arquivo] }}
                      </v-flex>
                    </v-flex>
                  </v-layout>
                  <v-flex
                    class="pa-1"
                    ml-4
                  >
                    <v-radio-group
                      v-model="arquivoSelecionado.arquivo.situacaoArquivo.st_situacao"
                      row
                      disabled
                    >
                      <v-radio
                        label="Regular"
                        class="v-label"
                        value="REGULAR"
                      />
                      <v-radio
                        label="Irregular"
                        class="v-label"
                        value="IRREGULAR"
                      />
                    </v-radio-group>
                  </v-flex>
                  <v-flex
                    pa-3
                  >
                    <v-textarea
                      v-model="arquivoSelecionado.arquivo.situacaoArquivo.ds_avaliacao"
                      box
                      label="Observação"
                      name="input-7-4"
                      rows="5"
                      row-height="20"
                      no-resize
                      disabled
                    />
                  </v-flex>
                </v-card>
                </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import conselhoUtils from '../../conselho/utils/conselhoUtils';
import codigosFase from '../../fase/utils/codigosFase';

import CardCarregando from '../../shared/components/CardCarregando';
import DialogConfirmacao from '../../shared/components/DialogConfirmacao';
import IndicacaoConselhoHabilitacaoComponent from '../../conselho/views/components/IndicacaoConselhoHabilitacaoComponent.vue';
import SingleFileUpload from '../../shared/components/SingleFileUpload';

export default {
  components: {
    CardCarregando,
    DialogConfirmacao,
    IndicacaoConselhoHabilitacaoComponent,
    SingleFileUpload,
  },
  data: () => ({
    codigosFase,
    conselhoUtils,
    modalSituacaoArquivo: false,
    arquivoSelecionado: {},
    tabs: null,
    dialog: false,
    valid: false,
    isUsuarioPermitido: false,
    usuarioLogado: {},
    perfilUsuario: {},
    loading: true,
    cardsDisabled: false,
    recurso_indicacao_conselho: {
      ds_recurso: null
    },
    indicado: {},
    arquivos: [
      {
        tp_arquivo: 'foto_indicado',
        title: 'Foto de rosto*',
      },
      {
        tp_arquivo: 'curriculo_indicado',
        title: 'Currículo*',
      },
      {
        tp_arquivo: 'curriculo_resumido_indicado',
        title: 'Currículo resumido para a candidatura*',
      },
      {
        tp_arquivo: 'portifolio_indicado',
        title: 'Portifólio*',
      },
      {
        tp_arquivo: 'cmpr_atuacao',
        title: 'Comprovação, por meio de portaria de designação ou termo de posse, de atuação em instâncias colegiadas nos últimos 10 anos, se houver',
      },
      {
        tp_arquivo: 'cpf_indicado',
        title: 'Cópia do documento de identificação (conforme item 2.8 deste edital) e CPF*',
      },
      {
        tp_arquivo: 'cmpres_indicado',
        title: 'Comprovante de residência com o nome do indicado ou declaração de residência (ANEXO 6)*',
      },
      {
        tp_arquivo: 'autorizacao_indicado',
        title: 'Declaração que autoriza a Secretaria Especial da Cultura do Ministério do Turismo a divulgar as imagens e informações contidas na inscrição e que responsabiliza o candidato pelos documentos e materiais apresentados (ANEXO 2 do edital)*',
      },
      {
        tp_arquivo: 'declaracao_indicado',
        title: 'Declaração do indicado de que possui disponibilidade para compor o Conselho Nacional de Política Cultural - CNPC, no triênio 2022/2025 (ANEXO 2 do edital)*',
      },
      {
        tp_arquivo: 'delico_indicado',
        title: 'Documento que comprove a deliberação do Conselho, presencial ou virtual, para indicação dos candidatos*',
      },
      {
        tp_arquivo: 'termo_indicacao',
        title: 'Termo de indicação de representante do Conselho de Cultura assinado pelo presidente do conselho (ANEXO 5)*',
      },
    ],
    acceptedFileTypes: 'image/jpeg, application/pdf',
    rules: {
      required: value => !!value || 'Campo não preenchido',
      tamanhoMaximoCaracteres: value => (!!value && value.length <= 3000) || 'Máximo 3000 caracteres',
    },
  }),
  watch: {
    indicadosConselho(indicados) {
      this.obterPorConselho(this.usuarioLogado.co_conselho);
    },
    recursosIndicacao() {
      this.setIndicado(this.indicadosConselho[0]);
      this.loading = false;
      this.cardsDisabled = false;
    },
    usuarioLogado(user) {
      this.obterDadosConselho(user.co_conselho);
      this.obterIndicadosPorConselho(user.co_conselho);
      
    },
  },
  computed: {
    ...mapGetters({
      usuario: 'conta/usuario',
      perfil: 'conta/perfil',
      conselho: 'conselho/conselho',
      ativarRecursoIndicacaoConselho: 'fase/ativarRecursoIndicacaoConselho',
      estados: 'localidade/estados',
      indicadosConselho: 'conselho/indicadosConselho',
      recursosIndicacao: 'recurso/recursosIndicacao',
    }),
  },
  methods: {
    ...mapActions({
      definirMensagemSucesso: 'app/setMensagemSucesso',
      definirMensagemErro: 'app/setMensagemErro',
      obterIndicadosPorConselho: 'conselho/obterIndicadosPorConselho',
      obterDadosConselho: 'conselho/obterDadosConselho',
      downloadArquivo: 'shared/downloadArquivo',
      excluirArquivo: 'conselho/excluirArquivoIndicacao',
      enviarDadosRecursoIndicacaoConselho: 'recurso/enviarDadosRecursoIndicacaoConselho',
      obterPorConselho: 'recurso/obterPorConselho',
    }),
    respostaDialog(tipoResposta) {
      if (tipoResposta) {
        this.salvar();
      } else {
        this.fecharDialogo();
      }
    },
    salvar() {
      this.loading = true;

      const recurso = {
        co_conselho: this.indicado.co_conselho,
        co_indicado_conselho: this.indicado.co_indicado_conselho,
        ds_recurso: this.recurso_indicacao_conselho.ds_recurso
      }

      this.enviarDadosRecursoIndicacaoConselho(recurso)
        .then((response) => {
          this.definirMensagemSucesso(response.data.message);
          this.$router.push('/');
        }).finally(() => {
          this.loading = false;
          this.obterIndicadosPorConselho(this.indicado.co_conselho);
          this.fecharDialogo();
        });
    },
    abrirDialogo() {
      if (!this.$refs.form_recurso_indicacao.validate()) {
        return false;
      }
      this.dialog = true;
      return true;
    },
    fecharDialogo() {
      this.dialog = false;
    },
    removerArquivo(co_arquivo) {
      this.cardsDisabled = true;
      this.excluirArquivo({ coIndicado: this.indicado.co_indicado_conselho, coArquivo: co_arquivo })
        .finally(() => this.obterIndicadosPorConselho(this.indicado.co_conselho));
    },
    desabilitaCards() {
      this.cardsDisabled = true;
    },
    checkUsuario() {
      if (!this.isUsuarioPermitido) {
        this.definirMensagemErro('Conselho de Cultura ou Organizações e Entidades Cultural não associada ao perfil');
        this.$router.push('/').catch(() => {});
      }
      return true;
    },
    setIndicado(indicado) {
      this.indicado = indicado
      let recurso = this.recursosIndicacao.find(i => i.co_indicado_conselho = indicado.co_indicado_conselho);
      if(recurso){
        this.recurso_indicacao_conselho = recurso;
      } else {
        this.recurso_indicacao_conselho.ds_recurso = null;
      }

    },
    recursoSolicitado(){
      return !!this.recurso_indicacao_conselho && !!this.recurso_indicacao_conselho.co_indicado_conselho;
    },
    abrirDialogoSituacaoArquivo(arquivoSelecionado) {
      this.modalSituacaoArquivo = true;
      this.arquivoSelecionado = arquivoSelecionado;
    },
    fecharDialogoSituacaoArquivo() {
      this.modalSituacaoArquivo = false;
      this.arquivoSelecionado = {};
    },
  },
  mounted() {
    this.isUsuarioPermitido = (this.perfil.no_perfil == 'conselho');

    this.checkUsuario();

    this.usuarioLogado = this.usuario;
    this.perfilUsuario = this.perfil;
  },
};
</script>
